import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';
declare var $;

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[collapsible]',

})
export class CollapsibleDirective implements AfterViewInit {

  body: HTMLElement;
  lastHeight: number;

  @Input() collapsibleActive = true;
  @Input() set collapse(v) {
    if (v) {
      this.close();

    }
  }

  constructor(private el: ElementRef) {

  }

  ngAfterViewInit() {
    this.body = this.el.nativeElement.getElementsByTagName('nb-card-body')[0];
    if (this.body) {
      this.body.style.transition = 'all 0.7s';
    }
  }

  @HostListener('click', ['$event.target']) onMouseEnter(target) {
    if (![...$(target).parents()].map(e => e.tagName.toLowerCase()).includes('nb-card-header')) {
      return;
    }
    if (!this.collapsibleActive) {
      if (this.lastHeight) {
        this.body.style.maxHeight = this.lastHeight + 'px';
      }
      this.body.style.padding = null;
      this.body.style.overflowY = 'hidden';
      return;
    }
    this.body?.classList.toggle('closed');
    if (this.body?.classList.contains('closed')) {
      this.close();
    } else {
      this.body.style.maxHeight = this.lastHeight + 'px';
      this.body.style.padding = null;
      this.body.style.overflowY = 'hidden';
    }
  }

  close() {
    this.body?.classList.add('closed');
    this.lastHeight = this.body.getBoundingClientRect().height;
    this.body.style.maxHeight = '0px';
    this.body.style.padding = '0px';
    this.body.style.overflowY = 'auto';
  }
}
